import Vue from 'vue'
import Router from 'vue-router'

import Top from '@/components/pages/Top.vue'
import SignUp from '@/components/pages/SignUp.vue'
import Confirmation from '@/components/pages/Confirmation.vue'
import SignIn from '@/components/pages/SignIn.vue'
import ForgotPassword from '@/components/pages/ForgotPassword.vue'
import ResetPassword from '@/components/pages/ResetPassword.vue'
import User from '@/components/pages/User.vue'
import Account from '@/components/pages/Account.vue'
import Room from '@/components/pages/Room.vue'
import UserPolicy from '@/components/pages/UserPolicy.vue'
import PrivacyPolicy from '@/components/pages/PrivacyPolicy.vue'
import PaidVersionPrivacyPolicy from '@/components/pages/PaidVersionPrivacyPolicy.vue'
import Help from '@/components/pages/Help.vue'
import Contact from '@/components/pages/Contact.vue'

// errors
import NotFound from '@/components/pages/errors/NotFound.vue'

import store from '@/store'

Vue.use(Router)

const routes = [
  { path: '/', name: 'top', component: Top },
  { path: '/sign_up', name: 'signUp', component: SignUp, meta: { requires: 'notLoggedIn' } },
  { path: '/confirmation', name: 'confirmation', component: Confirmation },
  { path: '/sign_in', name: 'signIn', component: SignIn, meta: { requires: 'notLoggedIn' } },
  { path: '/forgot_password', name: 'forgotPassword', component: ForgotPassword, meta: { requires: 'notLoggedIn' } },
  { path: '/reset_password', name: 'resetPassword', component: ResetPassword, meta: { requires: 'notLoggedIn' } },
  { path: '/user', name: 'user', component: User, meta: { requires: 'loggedIn' } },
  { path: '/account', name: 'account', component: Account, meta: { requires: 'loggedIn' } },
  { path: '/user_policy', name: 'userPolicy', component: UserPolicy },
  { path: '/privacy_policy', name: 'privacyPolicy', component: PrivacyPolicy },
  { path: '/paid_version_privacy_policy', name: 'paidVersionPrivacyPolicy', component: PaidVersionPrivacyPolicy },
  { path: '/help', name: 'help', component: Help },
  { path: '/contact', name: 'contact', component: Contact },
  { path: '/:roomName', name: 'room', component: Room },
  { path: '*', name: 'notFound', component: NotFound }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  store.dispatch('clearHttpStatus')
  const requiresType = to.matched[0].meta.requires
  switch (requiresType) {
    case 'notLoggedIn': {
      const decide = () => {
        if (store.getters['auth/signedIn']) {
          next({ path: '/' })
        } else {
          next()
        }
      }
      if (store.getters['auth/initialized']) {
        decide()
      } else {
        const unwatch = store.watch((state, getters) => getters['auth/initialized'], () => {
          unwatch()
          decide()
        })
      }
      break
    }
    case 'loggedIn': {
      const decide = () => {
        if (store.getters['auth/signedIn']) {
          next()
        } else {
          next({ path: '/sign_in', query: { redirect: to.fullPath } })
        }
      }
      if (store.getters['auth/initialized']) {
        decide()
      } else {
        const unwatch = store.watch((state, getters) => getters['auth/initialized'], () => {
          unwatch()
          decide()
        })
      }
      break
    }
    default: {
      next()
    }
  }
})

export default router
